'use strict';

import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React, { Component } from 'react';
import View from "react-native-web/dist/exports/View";
import TouchableOpacity from "react-native-web/dist/exports/TouchableOpacity";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import computeProps from "../Utils/computeProps";

var RowNB = function (_Component) {
  _inherits(RowNB, _Component);

  function RowNB() {
    _classCallCheck(this, RowNB);

    return _possibleConstructorReturn(this, _getPrototypeOf(RowNB).apply(this, arguments));
  }

  _createClass(RowNB, [{
    key: "prepareRootProps",
    value: function prepareRootProps() {
      var flattenedStyle = StyleSheet.flatten(this.props.style);
      var type = {
        flexDirection: 'row',
        flex: this.props.size ? this.props.size : flattenedStyle && flattenedStyle.height ? 0 : 1
      };
      var defaultProps = {
        style: type
      };
      return computeProps(this.props, defaultProps);
    }
  }, {
    key: "setNativeProps",
    value: function setNativeProps(nativeProps) {
      this._root.setNativeProps(nativeProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      if (this.props.onPress) {
        return React.createElement(TouchableOpacity, _extends({
          onPress: this.props.onPress
        }, this.prepareRootProps()), React.createElement(View, _extends({
          ref: function ref(component) {
            return _this._root = component;
          }
        }, this.props, this.prepareRootProps()), this.props.children));
      } else {
        return React.createElement(View, _extends({
          ref: function ref(component) {
            return _this._root = component;
          }
        }, this.props, this.prepareRootProps()), this.props.children);
      }
    }
  }]);

  return RowNB;
}(Component);

export { RowNB as default };